import { SwxTheme } from 'swx-atomic-component-lib'

export default {
  blue: SwxTheme.palette.primary,
  black: SwxTheme.palette['secondary-dark'],
  grey: SwxTheme.palette['secondary-mid'],
  white: SwxTheme.palette.white,
  disabled: SwxTheme.palette.sel,
  error: SwxTheme.palette.highlight,
  check: SwxTheme.palette.dis,
  magic: SwxTheme.palette.g200,
  footer: SwxTheme.palette['secondary-light'],
  success: SwxTheme.palette['primary-alt']
}
